import React from "react";

function FormPostStay() {
  return <div>configuration du formulaire in stay</div>;
}

export default FormPostStay;
